import React from "react";
import "./Ready-To-Make-Your-Dream-Team.css";
function Ready_To_Make_Your_Dream_Team() {
  return (
    <section className="dream-team-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6">
            <div className="dream-content">
              <h2>
                READY TO MAKE <br />
                YOUR DREAM TEAM?
              </h2>

              <p>
                Download the 11 Dreams App now and get instant 100% bonus on
                your first deposit!
              </p>

              <a
                href="https://play.google.com/store/games?device=windows"
                target="_blank"
                rel="noopener noreferrer"
                className="playstore-btn"
              >
                <img
                  src="/assets/images/about-11-dream/google-play-btn.png"
                  alt="Google Play"
                  className="google-play-img"
                />
              </a>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 text-center">
            <div className="dream-image-wrapper">
              <img
                src="/assets/images/Ready_To_Make_Dream_Team/mobile-image.png"
                alt="App Preview"
                className="dream-mobile-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Ready_To_Make_Your_Dream_Team;
